import { render, staticRenderFns } from "./export-ppt-records.vue?vue&type=template&id=6cf39550&scoped=true"
import script from "./export-ppt-records.vue?vue&type=script&lang=js"
export * from "./export-ppt-records.vue?vue&type=script&lang=js"
import style0 from "./export-ppt-records.vue?vue&type=style&index=0&id=6cf39550&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf39550",
  null
  
)

export default component.exports